import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
} from "@mui/material";

import Divider from "@mui/material/Divider";

import "./RenameMapDialog.css";
import { updateMapName } from "../../Map/store/MapDisplayThunks";

const RenameMapDialog = ({
  open,
  map,
  onClose,
  onUpdated,
}) => {

  const dispatch = useDispatch();

  const [mapName, setMapName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (map) {
      setMapName(map.name);
      setError("");
    }
  }, [map]);

  const handleSave = async () => {
    try {
      setLoading(true);
      setError("");

      await dispatch(
        updateMapName({
          id: map.id,
          name: mapName.trim(),
        })
      ).unwrap();

      onUpdated(); // recharge la liste des maps
      onClose();   // ferme le dialog
    } catch (err) {
      setError(err?.message || "Impossible de renommer la map.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle className="gestion-user-dialog-title">
        <div className="title-dialog">
          <h2>
            <span class="material-symbols-outlined">
              map
            </span>
            Renommer la map
          </h2>

          <span className="material-symbols-outlined cursor-pointer" onClick={onClose}>
            close
          </span>
        </div>
        <Divider
          sx={{
            marginTop: "0.125rem",
            marginBottom: "0.8125rem",
            backgroundColor: "#CDD5DF",
          }}
        />
      </DialogTitle>

      <DialogContent className="rename-map-dialog">
        <TextField
          className="map-name-field"
          autoFocus
          fullWidth
          margin="normal"
          label="Nom de la map"
          value={mapName}
          onChange={(e) => setMapName(e.target.value)}
          error={!!error}
        />

        {error && (
          <Typography
            color="error"
            variant="body2"
            sx={{ mt: 1 }}
          >
            {error}
          </Typography>
        )}
      </DialogContent>

      <DialogActions className="rename-map-actions">
        <Button
          className="grey-btn"
          onClick={onClose}
          disabled={loading}
        >
          Annuler
        </Button>

        <Button
          className="primary-button"
          variant="contained"
          onClick={handleSave}
          disabled={
            loading ||
            !mapName.trim() ||
            mapName.trim() === map?.name
          }
        >
          {loading ? "Enregistrement..." : "Enregistrer"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RenameMapDialog;